import { render } from "./ProfileAccountChangePasswordContent.vue?vue&type=template&id=407510e7&scoped=true"
import script from "./ProfileAccountChangePasswordContent.vue?vue&type=script&lang=js"
export * from "./ProfileAccountChangePasswordContent.vue?vue&type=script&lang=js"

import "./ProfileAccountChangePasswordContent.vue?vue&type=style&index=0&id=407510e7&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407510e7"]])

export default __exports__